import { JSONValue } from "@smile2impress/attraction-constants";
import { useUTSLocaleContext } from "context/utsLocaleContext";
import { getLocalizedPathname } from "modules/localize-pathnames/getLocalizedPathname";

import { UrlsConfig } from "configs/urlsConfig";
import { UTSLocaleToI18nLocale } from "constants/enum";
import contacts from "configs/contacts";

import { JSONSchemaServiceClinicContent } from "../JSONSchemaService.types";
import { formatSchedule, removePunctuationMarks } from "../utils";

export const ClinicJSONSchema = (
    content: JSONSchemaServiceClinicContent
): JSONValue => {
    const { locale } = useUTSLocaleContext();
    const { clinicEntity, image } = content;
    const { map, address, cityName, postalCode, clinicId, id, name, schedule } =
        clinicEntity;

    const pageUrl = `${UrlsConfig.HOME_PAGE_URL}/${
        UTSLocaleToI18nLocale[locale]
    }${getLocalizedPathname(
        UrlsConfig.CLINIC_RELAUNCH.replace("[id]", clinicId),
        UTSLocaleToI18nLocale[locale],
        true
    )}?clinic=${id}`;

    return {
        "@context": "https://schema.org",
        "@type": "LocalBusiness",
        "@id": pageUrl,
        url: pageUrl,
        telephone: contacts.phone[locale].link,
        name: removePunctuationMarks(name),
        address: {
            "@type": "PostalAddress",
            streetAddress: address,
            addressLocality: cityName,
            postalCode: postalCode,
            addressCountry: UTSLocaleToI18nLocale[locale].toLocaleUpperCase(),
        },
        openingHoursSpecification: formatSchedule(schedule),
        sameAs: [
            contacts.facebook[locale].link,
            contacts.instagram[locale].link,
            contacts.linkdin[locale].link,
            contacts.tiktok[locale].link,
        ].filter((el) => el?.length),
        ...(map && {
            geo: {
                "@type": "GeoCoordinates",
                latitude: map.latitude,
                longitude: map.longitude,
            },
        }),
        ...(image ? { image } : {}),
    } as JSONValue;
};
